import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as payrollExpenses from '../../payroll-expenses'

export const RESOURCE = {
  payload: {
    description:
      'A financial record documenting salary and benefit expenses for employees.',
    dimension: payrollExpenses.RESOURCE.payload,
    level: 0,
    name: 'Payroll Expense Entry',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
